/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Resumes_UpdatedInputs */

const en_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const de_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisiert am ${i?.date}`)
};

const fr_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mis à jour le ${i?.date}`)
};

const es_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizado el ${i?.date}`)
};

const it_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiornato ${i?.date}`)
};

const nl_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bijgewerkt ${i?.date}`)
};

const pl_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zaktualizowano ${i?.date}`)
};

const fi_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Päivitetty ${i?.date}`)
};

const da_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opdateret ${i?.date}`)
};

const sv_resumes_updated = /** @type {(inputs: Resumes_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uppdaterat ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Updated {date}" |
*
* @param {Resumes_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_updated = /** @type {((inputs: Resumes_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_updated(inputs)
	if (locale === "fr") return fr_resumes_updated(inputs)
	if (locale === "es") return es_resumes_updated(inputs)
	if (locale === "it") return it_resumes_updated(inputs)
	if (locale === "nl") return nl_resumes_updated(inputs)
	if (locale === "pl") return pl_resumes_updated(inputs)
	if (locale === "fi") return fi_resumes_updated(inputs)
	if (locale === "da") return da_resumes_updated(inputs)
	if (locale === "sv") return sv_resumes_updated(inputs)
	return en_resumes_updated(inputs)
});